import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import InputField from "../../components/InputField";
import { CardMedia } from "@mui/material";
import PasswordField from "../../components/PasswordField";
import { Form, Spinner } from "react-bootstrap";
import useLoginViewController from "../../viewControllers/LoginViewController";
import i18n from "../../constants/Strings";

const Login = () => {

  const {
    imageLogo,
    handleSubmit,
    values,
    handleChange,
    touched,
    errors,
    loading,
  } = useLoginViewController();

  const text = {
    loginBtn: i18n.t('login.loginBtn'),
    username: i18n.t('login.username'),
    password: i18n.t('login.password'),
  };

  return (
    <>
      <section className="vh-100">
        <div className="container py-5 h-100">
          <div className="row d-flex align-items-center justify-content-center h-100">
            <div className="col-md-8 col-lg-7 col-xl-6">
              <CardMedia component="img" image={imageLogo} alt="Paella dish" />
            </div>
            <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
              <Form onSubmit={handleSubmit}>
                <div className="form-outline mb-4">
                  <InputField
                    type="text"
                    placeholder={text.username}
                    value={values?.username}
                    onChange={handleChange("username")}
                    name="username"
                    errors={touched?.username && errors?.username}
                  />
                </div>

                <div className="form-outline mb-4">
                  <PasswordField
                    type="password"
                    placeholder={text.password}
                    value={values?.password}
                    onChange={handleChange("password")}
                    name="password"
                    errors={touched?.password && errors?.password}
                  />
                </div>
                {loading ? <Spinner /> : (
                  <PrimaryButton
                    type="submit"
                    text={text.loginBtn}
                    className="login-btn"
                  />
                )}
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
